import React, {useEffect, useState} from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import useMediaQuery from '@mui/material/useMediaQuery';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Logon from './Logon';
import RecordEdit from './Components/RecordEdit'
import RecordView from './Components/RecordView'
import ResponsiveGrid from './Components/ResponsiveGrid';

import {setViewRecord, setEditRecord, setViewNotes, setViewPhoneCalls, selectRow,setRowData } from './slices/dataSlice'
import {setSelectedTab } from './slices/uiSlice';
import {ttpcolumns} from './ttpcolumns.js'
import NotesArea from './Components/NotesArea.js'
import PhoneCallsArea from './Components/PhoneCallsArea.js'
import EmailClient from './Components/Email/EmailClient'
import Settings from './Settings'
import logo from './assets/logo.png'

/*interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}*/
import CustomTabPanel from './Components/CustomTabs/CustomTabPanel'
import  a11yProps from './Components/CustomTabs/a11yProps'


export default function App() {
    const isMobile = useMediaQuery('(max-width:768px)');
    const [loggedon,setLogged] = useState(false)
    const dispatch = useDispatch();
    const {
        records,
        viewRecord,
        editRecord,
        viewNotes,
        viewPhoneCalls,
        selectedRow,
        selectedColumn,
        selectedId,
        rowdata
    } = useSelector(state => state.data, shallowEqual);
    const selectedTab = useSelector(state => state.uislice.selectedTab, shallowEqual)


    useEffect(() => {
          dispatch(setViewRecord(false))
          dispatch(setEditRecord(false))
          dispatch(setViewNotes(false))
          dispatch(setViewPhoneCalls(false))
    },[dispatch])


    const handleChange = (event, newValue) => {
      dispatch(setSelectedTab(newValue))
    };

    const onLoggedOn = (authdata) => {
        setLogged(authdata.loggedon)
        if(authdata.loggedon) {
          //setAuthSetting(authdata)
          //setUserId(authdata.flg_userid)
        }
      }

      if(!loggedon)
        return (
          <Logon onChange={onLoggedOn}/>
      )

      const processRowUpdate = (newRow) => {
        const updatedRow = { ...newRow, isNew: false };
        dispatch(selectRow(newRow.id))
        dispatch(setRowData(records.map((row) => (row.id === newRow.id ? updatedRow : row))));
        return updatedRow;
      };
    //if(loading)
    //    return ( <h1>System Loading...</h1>)


    return (
      <div style={{width: '100%', height: '100vh'} }>
        <Box sx={{ width: '100%', height: '100vh' }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2, height: '65px' }}>
          {isMobile ? (
            <div style={{width: '100%', height: '100vh'} }>
            <img src={logo} style={{height: '50px', float: 'right'}} alt="TTP Logo" />
            <Select
              value={selectedTab}
              onChange={(e) => handleChange(e, e.target.value)}
              fullWidth
              size="small"
            >
              <MenuItem value={0}></MenuItem>
              <MenuItem value={1}>Leads</MenuItem>
              <MenuItem value={2} disabled={!viewRecord}>View Lead</MenuItem>
              <MenuItem value={3} disabled={!editRecord}>Edit Lead</MenuItem>
              <MenuItem value={4} >Email</MenuItem>
              <MenuItem value={5} >Settings</MenuItem>
            </Select>
            </div>
          ) : (
            <Tabs value={selectedTab} onChange={handleChange} >
              <Tab label="___" {...a11yProps(0)} component={()=> (<Button onClick={() => dispatch(setSelectedTab(0))}><img src={logo} style={{height: '50px', float: 'right'}} alt="TTP Logo" /></Button>)} />
              <Tab label="Leads" {...a11yProps(1)} />
              <Tab label="View Lead" {...a11yProps(2)} disabled={!viewRecord} />
              <Tab label="Edit Lead" {...a11yProps(3)} disabled={!editRecord} />
              <Tab label="Emails" {...a11yProps(4)} />
              <Tab label="Settings" {...a11yProps(5)} />
            </Tabs>
          )}
        </Box>

        <CustomTabPanel value={selectedTab} index={0}>
          <ResponsiveGrid />
        </CustomTabPanel>

        <CustomTabPanel value={selectedTab} index={1}>
          <ResponsiveGrid />
        </CustomTabPanel>

        <CustomTabPanel disabled value={selectedTab} index={2}>
        {viewRecord && <RecordView  id={selectedId} data={rowdata} cols={ttpcolumns} row={selectedRow} col={selectedColumn}  onUpdate={processRowUpdate} /> }
        </CustomTabPanel>

        <CustomTabPanel value={selectedTab} index={3}>
        {editRecord && <RecordEdit  id={selectedId} data={rowdata} cols={ttpcolumns} row={selectedRow} col={selectedColumn}  onUpdate={processRowUpdate} /> }
        </CustomTabPanel>

        <CustomTabPanel value={selectedTab} index={4}>
          {selectedTab ===4 && <div style={{display: 'flex', flexDirection: 'column'}}>
          <h2>Emails</h2>
            {!rowdata && <p>You need to Select a Record To Use Emails</p>}
            {rowdata &&
              <EmailClient key={`phonecalls_app` } accordion={false}  data={rowdata??null} refresh={Date.now()} />
            }
          </div>}
        </CustomTabPanel>

        <CustomTabPanel value={selectedTab} index={5}>
          {selectedTab ===5 && <Settings /> }
        </CustomTabPanel>
        </Box>
      </div>
    )

}
